$('.autoplay').slick({
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  arrows: true,
  variableWidth: true
});

$('.testimonial-slider__text').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  dots:false,
  arrows:true,
  speed: 1000,
  fade: true,
  autoplay: true,
  autoplaySpeed: 4000,
  prevArrow: $('.left-arrow-wrap'),
  nextArrow: $('.right-arrow-wrap'),
  asNavFor: '.testimonial-slider__image'
});

$('.testimonial-slider__image').slick({
  centerMode:true,
  variableWidth: true,
  variableHeight: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  dots:false,
  arrows:false,
  speed: 1000,
  autoplay: true,
  autoplaySpeed: 4000,
  asNavFor: '.testimonial-slider__text',
  responsive: [
    {
      breakpoint: 1023,
      settings: {
        slidesToShow: 1,
        variableHeight: false
      }
    }
  ]
});